module.exports = __webpack_public_path__ + "static/media/keterampilan.c6689cfc.svg";